export default "__VITE_ASSET__DIUk6Ta5__"